import { useRMSelector } from 'redux/hooks';

export const useIngredientsDataIndicator = () => {
  return useRMSelector((state) => state.ingredientsTable.ingTableDataIndicator);
};
